import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from '@kallidus/common';
import getRedirectionUrl from './getRedirectionUrl';
import { usePreAuthConfig } from '@ApplicationWide/auth/usePreAuthConfig';
import './LoginWithSSO.less';

export default function LoginWithSSO() {
  const preAuthConfig = usePreAuthConfig();

  const { t } = useTranslation();

  const loginTranslations = {
    shibboleth: t('auth.buttons.login-options.shibboleth'),
    okta: t('auth.buttons.login-options.okta'),
    'ping-id': t('auth.buttons.login-options.ping-id'),
    'one-login': t('auth.buttons.login-options.one-login'),
    'adfs-kpmg': t('auth.buttons.login-options.adfs-kpmg'),
    'adfs-martin-agency': t('auth.buttons.login-options.adfs-martin-agency'),
    'google-sso': t('auth.buttons.login-options.google-sso'),
    'azure-ad': t('auth.buttons.login-options.azure-ad'),
  };

  const ssoLoginOptions = preAuthConfig.loginOptions.ssoLoginOptions;

  const handleSsoLoginRedirection = useCallback((redirectionLink, isCompleteLink, isOriginRequired, identifier) => {
    const redirectionUrl = getRedirectionUrl(redirectionLink, isCompleteLink, isOriginRequired, identifier);
    window.location.href = redirectionUrl;
  }, []);

  return ssoLoginOptions.map(({ identifier, redirectionLink, isCompleteLink, isOriginRequired }) => {
    const ssoIdentifier = loginTranslations[identifier];
    return (
      <SecondaryButton
        key={identifier}
        className='auth-login-options-button-spacing'
        onClick={() => handleSsoLoginRedirection(redirectionLink, isCompleteLink, isOriginRequired, identifier)}
      >
        {t('auth.buttons.login-with-sso', { ssoIdentifier })}
      </SecondaryButton>
    );
  });
}
